export default __webpack_public_path__ + "static/media/assistedJourneyGrey.a42e1071.svg";